'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'query';
var actionTypes = exports.actionTypes = {
  SET_QUERIES: NAME + '/SET_QUERIES',
  CLEAR_QUERIES: NAME + '/CLEAR_QUERIES'
};